import { faEye, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { Component } from "react";
import { Button, Table, Modal, ButtonGroup } from "react-bootstrap";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";

export default class ListaAdjuntos extends Component {
  constructor(props) {
    super(props);

    this.state = {
      modalEliminar: false,
      archivoSel: null
    };
  }


  borra_documento = (e) => {
    this.setState({ archivoSel: e })
    this.showModalEliminar()
  };

  abre_documento = (url_doc) => {
    window.open(url_doc, "_blank")
  };

  borra_real = (e) => {
    let el = this.state.archivoSel
    let config = {};
    let data = {
      api_token: localStorage.api_token,
    };
    axios
      .delete(
        "http://143.198.191.211/api/Documento/" +
        el.id +
        "?api_token=" +
        localStorage.api_token,
        data,
        config
      )
      .then((res) => {
        this.closeModalEliminar();
        toast.success(res.data.text, { autoClose: 1000 });
        this.props.cargaDocumentos(this.props.rowId)
        //this.cargaTabla();
        this.setState({ loading: false });
      });
  };

  showModalEliminar = () => {
    this.setState({ modalEliminar: true });
  };

  closeModalEliminar = () => {
    this.setState({ modalEliminar: false });
  };

  render() {
    const { modalEliminar, archivoSel } = this.state;

    let archivos = this.props.archivos.map((el) => {
      const url_doc =
        "http://143.198.191.211/api/securedocs/" +
        el.filename +
        "?api_token=" +
        localStorage.api_token;
      return (
        <tr key={el.id}>
          <td>
            <a href={url_doc} target="_blank">
              {el.descripcion}
            </a>
          </td>
          <td>
            <ButtonGroup size="sm">
              <button
                type="button"
                className="btn btn-outline-info btn-sm"
                size="sm"
                onClick={() => this.abre_documento(url_doc)}
                data-tip="Visualizar"
              >
                <FontAwesomeIcon icon={faEye} size="lg" />
              </button>
              <button
                type="button"
                className="btn btn-outline-danger btn-sm"
                size="sm"
                onClick={() => this.borra_documento(el)}
                data-tip="Eliminar"
              >
                <FontAwesomeIcon icon={faTrash} size="lg" />
              </button>
            </ButtonGroup>
          </td>
        </tr>
      );
    });

    return (
      <div style={{
        maxHeight: "45vh",
        overflowY: "auto",
        overflowX: "hidden"
      }}>
        <ToastContainer />
        <Table bordered size="sm" className="tabla-perfil">
          <thead>
            <tr>
              <th>Descripción</th>
              <th style={{ width: "42px" }}></th>
            </tr>
          </thead>
          <tbody>
            {archivos}
          </tbody>
        </Table>
        <Modal
          show={modalEliminar}
          onHide={this.closeModalEliminar}
          size="sm"
          centered
        >
          <Modal.Header>
            <Modal.Title>Eliminar</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Seguro que desea eliminar el archivo <b>
              {archivoSel ? archivoSel.descripcion : ""}
            </b>?
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.closeModalEliminar}>
              Cancelar
            </Button>
            <Button variant="danger" onClick={this.borra_real}>
              Eliminar
            </Button>
          </Modal.Footer>
        </Modal>
        <br></br>
      </div>
    );
  }
}
